<template>
  <div class="widget" v-if="loaded && selectedMeeting">
    <div class="panel">
      <div class="panel-heading">
        <h2>
          Live Session File Share<i class="clippie fa fa-info-circle" v-tooltip="
              'A place to share files with your supervisor for each live session'
            "></i><i class="fa fa-refresh" @click="getMeetings()"></i>
        </h2>
        <div class="toggle-widget" @click="toggle()">
          <i :class="toggleClass"></i>
        </div>
      </div>
      <div class="panel-body" v-show="open">
        <select :disabled="selectedMeeting.downloading" v-model="termId" @change="changeTerm()" v-if="roles.includes('Supervisor') || roles.includes('Student')">
          <option v-for="term, $index in terms" :value="$index" :key="term.id">
            {{term.name}}
          </option>
        </select>

        <select :disabled="selectedMeeting.downloading" v-if="roles.includes('Supervisor')" v-model="groupId" @change="changeGroup()">
          <option v-for="group, $index in terms[termId].studentGroup" :value="$index" :key="group.id">
            {{group.label}}
          </option>
        </select>

        <select :disabled="selectedMeeting.downloading" v-model="meetingId">
          <option v-for="meeting in terms[termId].studentGroup[groupId].meetings" :value="meeting.id" :key="meeting.id">
            {{ meetingTitle(meeting) }}
          </option>
        </select>

        <div class="meeting">
          <div v-if="selectedMeeting.users.length == 0">
            No files have been shared.
          </div>

          <span v-else-if="roles.includes('Supervisor') && selectedMeeting.users.length > 1 && !selectedMeeting.downloading" @click="downloadAllStudents()" class="downloadAll">Download All Student Files</span>
          <span v-if="selectedMeeting.downloading">Downloading All Student Files...<i class="fa fa-ban" @click="cancelDownload(selectedMeeting)"></i></span>

          <div v-for="user in selectedMeeting.users" :key="user.id">
            <div class="user"> {{ username(user) }}
              <span v-if="!user.downloading" class="downloadAll" @click="downloadAll(user)">(Download All)</span>
              <span v-else-if="user.zipping">(Zipping...)</span>
              <span v-else>(Downloading...)<i v-if="!selectedMeeting.downloading" class="fa fa-ban" @click="cancelDownload(user)"></i></span>
            </div>

            <div v-for="file, file_index in user.files" :key="file.id" class="file">
              <a :href="file.url" :download="file.name">
                {{ filename(file) }}{{file.deleting ? " deleting..." : ""}}
              </a>
              <div v-if="user.downloading" class="downloadBar">
                <div class="filler" :style="{width:file.progress}"></div>
              </div>
              <i class="fa fa-trash" v-if="!user.downloading && user.id == userId && !file.deleting" @click="deleteFile(file, file_index, user.files)"></i>
            </div>
            <div v-if="user.zipping" class="zipDownloadBar">
              <div class="filler" :style="{width:user.zipping}"></div>
              <div class="zip">Zipping: {{user.zipfile}}</div>
            </div>
          </div>
          <div v-if="selectedMeeting.zipping" class="zipDownloadBar">
            <div class="filler" :style="{width:selectedMeeting.zipping}"></div>
            <div class="zip">Zipping: {{selectedMeeting.zipfile}}</div>
          </div>
        </div>
        <input type="file" id="file-upload" multiple @change="setFile" :disabled="selectedMeeting.downloading" />
        <button :disabled="selectedMeeting.downloading"><label :class="{disabled:(selectedMeeting.downloading)}" for="file-upload"></label>{{selectedMeeting.downloading ? "Uploads Disabled" : "Upload Files(s)"}}</button>
        <div class="loading" v-if="loading">
          <loader />
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import axios from "axios";
import moment from "moment";
import Aws from "../../services/aws";
import Loader from "./Loader.vue";
import jszip from "jszip";
import JSZipUtils from "jszip-utils";
import FileSaver from "../../../node_modules/file-saver/dist/FileSaver.js";
import toastr from "toastr";

export default {
  components: { Loader },
  data() {
    return {
      open: true,
      loading: false,
      loaded: false,
      termId: 0,
      groupId: 0,
      meetingId: 0,
      terms: [],
      cancel: [],
      downloading: false,
    };
  },
  sockets: {
    bulletinReceived(message) {
      if (message.text.includes("shared file(s)")) this.getMeetings();
    },
  },
  mounted() {
    this.getMeetings();
  },
  methods: {
    toggle() {
      this.open = !this.open;
    },
    changeTerm() {
      this.groupId = 0;
      this.meetingId = this.terms[this.termId].studentGroup[0].meetings[0].id;
    },
    changeGroup() {
      this.meetingId =
        this.terms[this.termId].studentGroup[this.groupId].meetings[0].id;
    },
    meetingTitle(meeting) {
      let title = `Week ${this.getWeek(
        meeting.startTime,
        this.terms[this.termId].startDate
      )} - ${this.$options.filters.checkinDate(meeting.startTime)}`;
      if (this.terms[this.termId].type == "mentorship") {
        title += `, ${this.$options.filters.timeOnly(meeting.startTime)}`;

        meeting.students.forEach((student) => {
          title += `, ${student.firstName} ${student.lastName}`;
        });
      }
      return title;
    },
    username(user) {
      return user.isSupervisor
        ? "Supervisor " + user.name.split(" ")[0]
        : user.name;
    },
    filename(file) {
      return (
        file.name.substring(0, file.progress ? 12 : 24) +
        (file.name.length > (file.progress ? 12 : 24) ? "..." : "")
      );
    },
    getMeetings() {
      this.loading = true;

      let options = {
        url: window.apiUrl + "/live-session-file-share",
        headers: { Authorization: "Bearer " + localStorage.token },
      };

      axios.request(options).then((response) => {
        // console.log(response.data);

        response.data.forEach((term) => {
          term.studentGroup.forEach((group) => {
            group.meetings.forEach((meeting) => {
              meeting.users = [];
              meeting.zipping = false;
              meeting.zipfile = false;
              meeting.meeting_files.forEach((file) => {
                file.progress = 0;
                if (
                  file.userId == this.userId ||
                  file.user.roles.includes("Supervisor") ||
                  file.user.roles.includes("Mentor") ||
                  this.roles.includes("Supervisor") ||
                  this.roles.includes("Mentor")
                ) {
                  if (!meeting.users.find((e) => e.id == file.user.id))
                    meeting.users.push({
                      name: file.user.firstName + " " + file.user.lastName,
                      id: file.user.id,
                      files: [],
                      isSupervisor:
                        file.user.roles.includes("Supervisor") ||
                        file.user.roles.includes("Mentor"),
                      downloading: false,
                      zipping: false,
                      zipfile: false,
                      downloadEvent: null,
                    });
                  file.deleting = false
                  meeting.users
                    .find((e) => e.id == file.user.id)
                    .files.push(file);
                  delete file.user;
                  meeting.users = meeting.users.sort(
                    (f, s) => s.isSupervisor - f.isSupervisor
                  );
                }
              });
              delete meeting.meeting_files;
            });
          });
        });
        this.terms = response.data;
        if (!this.meetingId && response.data.length > 0)
          this.meetingId = response.data[0].studentGroup[0].meetings[0].id;

        this.loading = false;
        this.loaded = true;
      });
    },
    // getParticipants
    presignedUrl(key, method) {
      var options = {
        url: window.apiUrl + "/live-session-file-share/presigned-url",
        headers: { Authorization: "Bearer " + localStorage.token },
        method: "POST",
        data: { method, key },
      };
      return axios.request(options).then(function (response) {
        return response.data;
      });
    },
    signature(file, filename, realfilename) {
      var options = {
        url: window.apiUrl + "/live-session-file-share/signature",
        headers: { Authorization: "Bearer " + localStorage.token },
        method: "POST",
        data: { filename, filetype: file.type, realfilename },
      };
      return axios.request(options).then(function (response) {
        return response.data;
      });
    },
    async uploadFileToS3(filename, file) {
      let me = this.selectedMeeting.users.find(
        (u) => u.id == localStorage.user_id
      );
      let exists = false;
      filename = filename.split(".");
      // console.log(filename)
      if (me)
        exists = me.files.filter(
          (f) =>
            f.name.startsWith(filename[0]) &&
            f.name.endsWith(filename[filename.length - 1])
        ).length;

      if (exists) {
        filename.splice(filename.length - 1, 0, `v${exists + 1}`);
      }

      filename = filename.join(".");
      // filename += exists ?  : ''
      let meeting = this.selectedMeeting;
      //console.log(meeting)
      let name = filename;
      filename = meeting.id + "/" + localStorage.user_id + "/" + filename;

      //get signature for upload and presigned url
      const signature = await this.signature(file, filename, name);
      const presignedUrl = await this.presignedUrl(filename, "putObject");

      //upload file to s3
      const res = await Aws.upload(
        file,
        filename,
        signature,
        "ttto-live-session-file-share",
        presignedUrl,
        `attachment; filename="${name}"`
      );

      return { meetingId: meeting.id, url: res.url, name: name };
    },
    addFileToPortal(meetingFile) {
      let url = window.apiUrl + "/live-session-file-share";
      var options = {
        url: url,
        headers: { Authorization: "Bearer " + localStorage.token },
        method: "POST",
        data: meetingFile,
      };
      return axios.request(options).then((response) => {
        return response;
      });
    },
    deleteFile(meetingFile, index, files) {
      meetingFile.deleting = true
      let url = window.apiUrl + "/live-session-file-share/" + meetingFile.id;
      var options = {
        url: url,
        headers: { Authorization: "Bearer " + localStorage.token },
        method: "DELETE",
        data: {
          key:
            meetingFile.meetingId +
            "/" +
            localStorage.user_id +
            "/" +
            meetingFile.name,
        },
      };
      return axios.request(options).then((response) => {
        files.splice(index, 1);

        if (files.length == 0) this.getMeetings();

        return response;
      });
    },
    getWeek(meetingStartDate, termStartDate) {
      return moment(meetingStartDate).diff(termStartDate, "week") + 1;
    },
    async setFile(ev) {
      let prohibited = [
        ".exe",
        ".bat",
        ".iso",
        ".reg",
        ".img",
        ".jar",
        ".msp",
        ".msi",
        ".hta",
        ".scr",
        ".com",
        ".msc",
        ".cpl",
        ".gadget",
        ".pif",
        ".application",
        ".scf",
        ".lnk",
        ".inf",
        ".wsc",
        ".wsh",
        ".cmd",
        ".js",
        ".jse",
        ".vb",
        ".vbs",
        ".vbe",
        ".ws",
        ".wsf",
        ".ps1",
        ".ps1xml",
        ".ps2",
        ".ps2xml",
        ".psc1",
        ".psc2",
        ".msh",
        ".msh1",
        ".msh2",
        ".mshxml",
        ".msh1xml",
        ".msh2xml",
      ];
      let uploaded = false;
      let cutoff = 3 * 1024 * 1024 * 1024;
      for (const file of ev.target.files) {
        let fail = false;
        for (const ext of prohibited) if (file.name.endsWith(ext)) fail = true;

        if (fail) {
          toastr.error(
            `Can't upload ${file.name} as it is of unsupported file type`
          );
          continue;
        }

        if (file.size > cutoff){
          toastr.error(
            `Can't upload ${file.name}. Maximum allowed file size is 3GB`
          );
          continue;
        }
        
        uploaded = true;
        let meetingFile = await this.uploadFileToS3(file.name, file);
        meetingFile = await this.addFileToPortal(meetingFile);
      }
      document.getElementById("file-upload").value = "";
      if (uploaded) {
        this.notifyGroup();
        this.getMeetings();
      }
    },
    async notifyGroup() {
      var options = {
        url: window.apiUrl + "/live-session-file-share/notifyGroup",
        headers: { Authorization: "Bearer " + localStorage.token },
        method: "POST",
        data: {
          groupId: this.terms[this.termId].studentGroup[this.groupId].id,
          meetingName: this.meetingTitle(this.selectedMeeting),
          participants: this.selectedMeeting.participants,
        },
      };
      return axios.request(options).then((response) => {
        return response;
      });
    },
    async downloadAll(user) {
      user.downloading = true;
      let zip = new jszip();

      for (const file of user.files) {
        try {
          let data = await this.download(file, user);
          zip.file(file.name, data, { binary: true });
        } catch (err) {
          this.finishDownload(user);
          break;
        }
      }
      if (user.downloading)
        zip
          .generateAsync({ type: "blob" }, (metadata) => {
            user.zipping = metadata.percent.toFixed(0) + "%";
            user.zipfile = metadata.currentFile;
          })
          .then((content) => {
            FileSaver.saveAs(content, user.name + ".zip");
            this.finishDownload(user);
          });
    },
    async downloadAllStudents() {
      let selectedMeeting = this.selectedMeeting;
      selectedMeeting.downloading = true;
      selectedMeeting.users.forEach((user) => {
        if (!user.isSupervisor) user.downloading = true;
      });

      let zip = new jszip();

      for (const user of selectedMeeting.users) {
        if (!user.isSupervisor) {
          zip.folder(user.name);
          for (const file of user.files) {
            try {
              let data = await this.download(file, selectedMeeting);
              zip.folder(user.name).file(file.name, data, { binary: true });
            } catch (err) {
              this.finishDownload(selectedMeeting);
              break;
            }
          }
          if (!selectedMeeting.downloading) break;
        }
      }

      if (selectedMeeting.downloading)
        zip
          .generateAsync({ type: "blob" }, (metadata) => {
            selectedMeeting.zipping = metadata.percent.toFixed(0) + "%";
            selectedMeeting.zipfile = metadata.currentFile;
          })
          .then((content) => {
            let week = String(
              this.getWeek(
                selectedMeeting.startTime,
                this.terms[this.termId].startDate
              )
            );
            if (week.length == 1) week = "0" + week;
            FileSaver.saveAs(content, `week_${week}_all_students.zip`);
            this.finishDownload(selectedMeeting);
          });
    },
    download(file, user) {
      return new Promise((resolve, reject) => {
        JSZipUtils.getBinaryContent(file.url, {
          progress: (e) => {
            user.downloadEvent = e.originalEvent.currentTarget;
            file.progress = e.percent.toFixed(0) + "%";
          },
          callback: (err, data) => {
            if (err) reject(err);
            else resolve(data);
          },
        });
      });
    },
    cancelDownload(user) {
      user.downloadEvent.abort();
    },
    finishDownload(object) {
      if (object.users)
        for (const user of object.users) this.finishDownload(user);
      else for (const file of object.files) file.progress = 0;

      object.downloading = false;
      object.zipping = false;
    },
  },
  computed: {
    toggleClass() {
      return this.open ? "fa fa-minus" : "fa fa-plus";
    },
    termsExist() {
      return this.terms.length > 0;
    },
    selectedMeeting() {
      
      if (this.terms[this.termId]) {
        return this.terms[this.termId].studentGroup[this.groupId].meetings.find(
          (e) => e.id == this.meetingId
        );
      }
    },
    roles() {
      return JSON.parse(localStorage.roles.split(","));
    },
    currentTerm() {
      return this.$store.getters.currentTerm;
    },
    userId() {
      return localStorage.user_id;
    },
  },
  watch: {
    currentTerm() {
      if (!this.loaded || this.terms.length == 0) return;
      let id = this.terms.findIndex(
        (e) => e.id == this.$store.getters.currentTerm.id
      );

      if (this.terms[id]) {
        this.termId = id
        this.meetingId = this.terms[this.termId].studentGroup[0].meetings[0].id;
        this.groupId = 0;
      }
    },
  },
};
</script>


<style  lang="scss" scoped>
.widget {
  position: relative;
}

.panel-body {
  padding: 2rem;
  padding-top: 1rem;
  display: flex;
  align-items: center;
  flex-direction: column;
}

select {
  background: #0e0e0e;
  color: white;
  border: none;
  width: 100%;
  height: 36px;
  padding-left: 1rem;
  margin-top: 1rem;

  &:focus-visible {
    outline-width: 0;
  }
}

.file {
  margin-left: 1rem;
  margin-right: 1rem;
  justify-content: space-between;
  display: flex;
  align-items: center;
}

.downloadAll {
  cursor: pointer;
  color: #33ccff;

  &:hover {
    text-decoration: underline;
  }
}

.meeting {
  margin-top: 2rem;
  width: 100%;
  position: relative;

  .user {
    margin-bottom: 0.5rem;
    margin-top: 1rem;
    position: relative;
  }

  .fa-ban {
    position: absolute;
    right: -14px;
    top: 4px;

    &:hover {
      color: #33ccff;
      cursor: pointer;
    }
  }
}

button {
  position: relative;
  margin-top: 2rem;
  background: #33ccff;
  color: #0e0e0e;
  width: 160px;
  height: 36px;
  border: transparent solid 1px;

  &:hover {
    background: #0e0e0e;
    color: white;
    border: #33ccff solid 1px;
  }

  &:disabled {
    background: #b0b0b0 !important;
    border: transparent solid 1px !important;
    color: #0e0e0e !important;
  }

  label {
    cursor: pointer;
    border: solid transparent 1px;
    position: absolute;
    top: 0;
    left: 0;
    bottom: -10px;
    right: 0;

    &.disabled {
      cursor: not-allowed;
    }
  }
}

.fa-trash {
  margin-left: 1rem;
  font-size: 16px;
  color: #b0b0b0;
  cursor: pointer;

  &:hover {
    color: #33ccff;
  }
}

.fa-refresh {
  opacity: 0.8;
  font-size: 17px;
  left: 10px;
  top: -2px;
  position: relative;
  width: 20px;
  height: 20px;
  display: inline-block;
  cursor: pointer;

  &:hover {
    color: #33ccff;
  }
}

input[type="file"] {
  opacity: 0;
  z-index: -1;
  position: absolute;
}

.loading {
  position: absolute;
  background: #222222;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
}

.downloadBar {
  position: relative;
  background: #0e0e0e;
  width: 90px;
  height: 10px;
  margin-top: 2px;
  border-radius: 2px;
  margin-left: 1rem;
}

.filler {
  position: absolute;
  height: 100%;
  left: 0;
  border-radius: 2px;
  background: #33ccff;
}

.zipDownloadBar {
  position: relative;
  background: #0e0e0e;
  width: calc(100% - 2rem);
  height: 20px;
  margin: 1rem;
  border-radius: 2px;

  .zip {
    position: absolute;
    height: 100%;
    width: 100%;
    text-align: center;
    color: white;
  }
}
</style>



// WEBPACK FOOTER //
// LiveSessionFileShare.vue?c5224db4